import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ROUTE } from "../lib/paths"; // ← добавили

export default function PromoCodes() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const emptyForm = {
    id: null as number | null,
    code: "",
    amount_rub: "",
    active: true,
    event_id: "",
    option_id: "",
    suboption_id: "",
    usage_limit: "",
    valid_from: "",
    valid_to: "",
    expires_at: "",
    note: "",
  };
  const [form, setForm] = useState({ ...emptyForm });

  async function load() {
    try {
      setLoading(true);
      setErr(null);
      const r = await api.adminPromo.list({ limit: 200 });
      setItems(r.items || []);
    } catch (e: any) {
      setErr(e?.message || "Не удалось загрузить список");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  function editRow(row: any) {
    setForm({
      id: row.id ?? null,
      code: String(row.code || ""),
      amount_rub: String(row.amount_rub ?? ""),
      active: !!row.active,
      event_id: row.event_id ? String(row.event_id) : "",
      option_id: row.option_id ? String(row.option_id) : "",
      suboption_id: row.suboption_id ? String(row.suboption_id) : "",
      usage_limit: row.usage_limit != null ? String(row.usage_limit) : "",
      valid_from: row.valid_from || "",
      valid_to: row.valid_to || "",
      expires_at: row.expires_at || "",
      note: row.note || "",
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function resetForm() {
    setForm({ ...emptyForm });
  }

  async function submit() {
    try {
      setErr(null);
      const payload = {
        code: form.code.trim().toUpperCase(),
        amount_rub: Number(form.amount_rub || 0),
        active: Boolean(form.active),
        event_id: form.event_id ? Number(form.event_id) : null,
        option_id: form.option_id ? Number(form.option_id) : null,
        suboption_id: form.suboption_id ? Number(form.suboption_id) : null,
        usage_limit: form.usage_limit ? Number(form.usage_limit) : null,
        valid_from: form.valid_from || null,
        valid_to: form.valid_to || null,
        expires_at: form.expires_at || null,
        note: form.note || null,
      };
      if (form.id) {
        await api.adminPromo.update({ id: form.id, ...payload });
      } else {
        await api.adminPromo.create(payload);
      }
      resetForm();
      await load();
    } catch (e: any) {
      setErr(e?.message || "Не удалось сохранить промокод");
    }
  }

  async function toggle(id: number, active: boolean) {
    await api.adminPromo.toggle(id, active);
    await load();
  }

  async function removeItem(id: number) {
    if (!confirm("Удалить промокод?")) return;
    await api.adminPromo.remove(id);
    await load();
  }

  const fmt = (n: number) => new Intl.NumberFormat("ru-RU").format(n);

  return (
    <div className="grid gap-4">
      {/* Header with back */}
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => ROUTE.go(ROUTE.super())}
          className="ui-btn-sm"
        >
          ← Назад
        </button>
        <div className="text-[22px] font-bold tracking-tight">Промокоды</div>
      </div>

      {/* === форма === */}
      <div className="ui-panel">
        <div className="mb-3 text-sm text-neutral-300">
          {form.id ? `Редактирование #${form.id}` : "Создание промокода"}
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <input
            placeholder="CODE2025"
            value={form.code}
            onChange={(e)=>setForm(f=>({ ...f, code: e.target.value.toUpperCase() }))}
            className="ui-input"
          />
          <input
            placeholder="Скидка ₽"
            value={form.amount_rub}
            onChange={(e)=>setForm(f=>({ ...f, amount_rub: e.target.value }))}
            className="ui-input"
          />
          <input
            placeholder="event_id"
            value={form.event_id}
            onChange={(e)=>setForm(f=>({ ...f, event_id: e.target.value }))}
            className="ui-input"
          />
          <input
            placeholder="usage_limit"
            value={form.usage_limit}
            onChange={(e)=>setForm(f=>({ ...f, usage_limit: e.target.value }))}
            className="ui-input"
          />

          <label className="flex items-center gap-2 text-white/80 sm:col-span-2">
            <input
              type="checkbox"
              checked={form.active}
              onChange={(e)=>setForm(f=>({ ...f, active: e.target.checked }))}
            />
            Активен
          </label>

          <div className="flex gap-2 sm:col-span-2">
            <button
              onClick={submit}
              className="btn-primary"
            >
              {form.id ? "Сохранить" : "Добавить"}
            </button>
            {form.id && (
              <button
                onClick={resetForm}
                className="ui-btn-sm"
              >
                Отмена
              </button>
            )}
        </div>
        </div>
        {err && <div className="mt-2 text-sm text-red-300">{err}</div>}
      </div>

      {/* === таблица === */}
      <div className="ui-panel">
        <div className="flex items-center justify-between mb-2">
          <div className="text-sm text-neutral-300">Список промокодов</div>
          <button
            onClick={load}
            className="ui-btn-sm text-xs"
          >
            Обновить
          </button>
        </div>

        {loading ? (
          <div className="text-sm text-neutral-300">Загружаем…</div>
        ) : (
          <table className="w-full text-left text-sm">
            <thead className="text-white/60">
              <tr>
                <th>Код</th>
                <th>Скидка</th>
                <th>Статус</th>
                <th>Лимит</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} className="border-t border-white/10">
                  <td>{it.code}</td>
                  <td>{fmt(Number(it.amount_rub||0))} ₽</td>
                  <td>
                    <span className={`px-2 py-0.5 rounded text-xs ${it.active ? 'bg-emerald-600/30 text-emerald-200' : 'bg-white/10 text-white/70'}`}>
                      {it.active ? 'active' : 'off'}
                    </span>
                  </td>
                  <td>{it.usage_limit ?? '—'}</td>
                  <td>
                    <div className="flex gap-2">
                      <button onClick={()=>editRow(it)} className="rounded bg-white/10 hover:bg-white/15 px-2 py-1 text-xs text-white">
                        Изменить
                      </button>
                      <button onClick={()=>toggle(it.id, !it.active)} className="rounded bg-white/10 hover:bg-white/15 px-2 py-1 text-xs text-white">
                        {it.active ? 'Выключить' : 'Включить'}
                      </button>
                      <button onClick={()=>removeItem(it.id)} className="rounded bg-red-500/20 hover:bg-red-500/30 px-2 py-1 text-xs text-red-100">
                        Удалить
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {!items.length && (
                <tr>
                  <td colSpan={5} className="py-2 text-white/70">
                    Нет промокодов
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
